import { useState } from 'react';
import axios from 'axios';
import IconAddPerson from '../../components/icons/IconAddPerson';
import IconAccepted from '../../components/icons/IconAccepted';
import IconClock from '../../components/icons/IconClock';
import IconCopyUrl from '../../components/icons/IconCopyUrl';
import language from '../../variables/language';
import PlatformAccessModal from './PlatformAccessModal';

// Lives in the same header slot regardless of state - a "grant access"
// button with no UserPlatform yet, or (once one exists) a status pill in
// its place: pending (with a copy/resend-link action) or active.
//
// The modal is mounted unconditionally (visibility via its own `isOpen`),
// NOT nested inside the "no platformUser yet" branch below - creating the
// account flips `platformUser` from null to a real object (via onChanged's
// refetch) WHILE the modal is still open showing its success/copy-link
// step, and nesting it under that branch would unmount it out from under
// the user the instant that happens, closing the modal before they ever
// see the link. This was a real bug caught during verification.
export default function PlatformAccessButton({ studentId, studentName, studentEmail, platformUser, onChanged }) {
   const lang = language[language.lang];
   const [modalOpen, setModalOpen] = useState(false);
   const [copied, setCopied] = useState(false);
   const [resending, setResending] = useState(false);

   const handleCopyLink = () => {
      if(resending || !platformUser) return;
      setResending(true);
      // Always goes through resend-activation rather than trusting a
      // possibly-stale activationLink from the last fetch - guarantees the
      // copied link is a live, non-expired token every time.
      axios.post('/api/platform-users/' + platformUser.id + '/resend-activation', null, { withCredentials: true })
         .then(response => {
            const link = response.data && response.data.activationLink;
            onChanged();
            if(!link) return;
            return navigator.clipboard.writeText(link).then(() => {
               setCopied(true);
               setTimeout(() => setCopied(false), 1500);
            });
         })
         .catch(() => {})
         .finally(() => setResending(false));
   };

   return (
      <>
         {!platformUser ? (
            <div className='student-card-platform-btn' onClick={() => setModalOpen(true)} title={lang.grantPlatformAccess}>
               <IconAddPerson style={{ width: 16, height: 16, fill: 'var(--lighttext-color)' }} />
            </div>
         ) : platformUser.active ? (
            <span className='student-card-platform-status active' title={lang.platformActiveHint}>
               <IconAccepted style={{ width: 14, height: 14 }} />
               {lang.platformActive}
            </span>
         ) : (
            <span className='student-card-platform-status pending'>
               <IconClock style={{ width: 14, height: 14 }} />
               {lang.platformPending}
               <span className='student-card-platform-copy-btn' onClick={handleCopyLink} title={lang.copyActivationLink}>
                  <IconCopyUrl style={{ width: 13, height: 13 }} />
                  {copied ? <span className='student-card-platform-copied-hint'>{lang.studentsPage.copied}</span> : ''}
               </span>
            </span>
         )}

         <PlatformAccessModal isOpen={modalOpen} studentId={studentId} studentName={studentName} studentEmail={studentEmail}
            onClose={() => setModalOpen(false)}
            onCreated={onChanged} />
      </>
   );
}
